/* eslint-disable react-hooks/exhaustive-deps, jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  LinearProgress,
  Skeleton,
  useMediaQuery,
  useTheme as MuiTheme,
  // useMediaQuery,
} from "@mui/material";

import Image from "../Image"; // Update with the actual import path of your Image component
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../style/theme";
import { useTabVisibility } from "../FreeTab/TabVisibility";
import { useUser } from "../../hooks/Authorize";
import axios from "axios";
// import { ServerImage } from "../../utilities/helper";

const esignServices = [
  {
    name: "Clikkle E-Sign",
    organization: "Send Or Document",
    totalEmployees: "0",
    logo: "e-sign/logo/2025/clikkle%20esign.png",
    type: "esign",
  },
];

const freeServices = [
  {
    name: "Clikkle Files",
    organization: "Rakesh Corp",
    totalEmployees: "0",
    logo: "files/logo/2025/clikkle%20files.png",
    type: "file",
  },
];

const Free = () => {
  const navigate = useNavigate();
  const { mode } = useTheme();
  const platformUser = useUser();
  const { hideTabs } = useTabVisibility();
  const [loading, setLoading] = useState(true); // New loading state
  const [organizations, setOrganizations] = useState([]);
  const theme = MuiTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handlePurchase = (id) => {
    hideTabs();
    localStorage.setItem("orgId", id);
    navigate(`/subscription/hr/purchase/${id}`);
  };
  const handlePurchaseFiles = () => {
    hideTabs();
    navigate(`/subscription/files/purchase`);
  };
  const handlePurchaseEsign = () => {
    hideTabs();
    navigate(`/subscription/esign/purchase`);
  };
  const handlePurchaseProjects = (id) => {
    hideTabs();
    localStorage.setItem("orgId", id);
    navigate(`/subscription/projects/purchase/${id}`);
  };
  const handlePurchaseWorksuite = (id) => {
    hideTabs();
    localStorage.setItem("orgId", id);
    navigate(`/subscription/worksuite/purchase/${id}`);
  };
  const handlePurchaseCampaigns = (id) => {
    hideTabs();
    localStorage.setItem("orgId", id);
    navigate(`/subscription/campaigns/purchase/${id}`);
  };
  const handlePurchaseChat = (id) => {
    hideTabs();
    localStorage.setItem("orgId", id);
    navigate(`/subscription/chat/purchase/${id}`);
  };

  console.log("organizations", organizations);
  const fetchOrganizations = async () => {
    try {
      setLoading(true);

      const userId = platformUser?._id;
      if (!userId) {
        console.warn(
          "Platform user ID is missing; skipping fetchOrganizations."
        );
        setOrganizations([]); // or keep existing state
        return;
      }

      // fire all three requests, but don't fail the whole operation if one fails
      const requests = [
        axios.get(`/subscription/check-file/${userId}`),
        axios.get(`/subscription/check-esign/${userId}`),
        axios.get(`/store/organization?userId=${userId}`),
      ];

      const results = await Promise.allSettled(requests);

      // results order corresponds to requests order
      const filesResSettled = results[0];
      const esignResSettled = results[1];
      const orgResSettled = results[2];

      // helper to safely extract data from fulfilled responses
      const safeData = (settled) =>
        settled && settled.status === "fulfilled"
          ? settled.value?.data
          : undefined;

      const filesData = safeData(filesResSettled) || {};
      const esignData = safeData(esignResSettled) || {};
      const orgData = safeData(orgResSettled) || {};

      // log any failures for debugging (but continue)
      results.forEach((r, idx) => {
        if (r.status === "rejected") {
          const which =
            idx === 0
              ? "check-file"
              : idx === 1
                ? "check-esign"
                : "store/organization";
          console.error(`API ${which} failed:`, r.reason);
        }
      });

      const filesSubscription = filesData.subscription || {};
      const esignSubscription = esignData.subscription || {};
      const fetchedOrganizations = Array.isArray(orgData.data)
        ? orgData.data
        : [];

      const isFree = {
        files: filesSubscription?.planName === "Free",
        esign: esignSubscription?.planName === "Free",
      };

      const additionalServices = [
        ...(isFree.files ? freeServices : []),
        ...(isFree.esign ? esignServices : []),
      ];

      // combine whatever orgs we got with any additional services
      setOrganizations([...fetchedOrganizations, ...additionalServices]);
    } catch (error) {
      // This catch should only trigger for unexpected errors in processing the results
      console.error("Unexpected error while fetching organizations:", error);
    } finally {
      // keep same UX: small delay for faster feedback
      setTimeout(() => setLoading(false), 1500);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps

  let currentStorage = JSON.parse(localStorage.getItem("storage"));
  let currentUserStorage = JSON.parse(localStorage.getItem("userStorage"));

  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i];
  };

  const convertToBytes = (value, unit) => {
    const units = {
      Bytes: 1,
      KB: 1024,
      MB: 1024 ** 2,
      GB: 1024 ** 3,
      TB: 1024 ** 4,
    };
    return value * (units[unit] || 1);
  };

  const used = currentUserStorage?.usedSpace || 0;
  const limit = convertToBytes(
    currentStorage?.permissions?.noOfAllowed || 0,
    currentStorage?.permissions?.format || "GB"
  );

  const percentage = limit > 0 ? (used / limit) * 100 : 0;

  useEffect(() => {
    fetchOrganizations();
  }, [platformUser]);
  const getImagePath = (s) => {
    const type = s.type?.toLowerCase();
    const name = s.name?.toLowerCase() || s.orgName?.toLowerCase();

    if (name?.includes("file") || type === "file" || type === "files")
      return "files/logo/2025/clikkle%20files.png";
    if (name?.includes("esign") || name?.includes("e-sign") || type === "esign")
      return "e-sign/logo/2025/clikkle%20esign.png";
    if (name?.includes("project") || type === "project" || type === "projects")
      return "projects/logo/2025/clikkle%20projects.png";
    if (name?.includes("chat") || type === "chat")
      return "chat/logo/2025/clikkle%20chat.png";
    if (name?.includes("campaign") || type === "campaigns")
      return "campaigns/logo/2025/clikkle%20campaigns.png";
    if (name?.includes("app") || name?.includes("worksuite") || type === "app" || type === "worksuite")
      return "worksuite/2025/clikkle%20worksuite.png";
    // if (name?.includes("ads") || type === "ads")
    //   return "ads/logo/2023/ads.png";
    // if (name?.includes("crm") || type === "crm")
    //   return "crm/2025/clikkle%20crm.png";
    // if (name?.includes("host") || type === "host")
    //   return "host/logo/2023/host.png";
    // if (name?.includes("launch") || type === "launch")
    //   return "launch/logo/2023/launch.png";
    // if (name?.includes("mail") || type === "mail")
    //   return "cmail/logo/2023/cmail.png";
    // if (name?.includes("pitch") || type === "pitch")
    //   return "pitch/logo/2023/pitch.png";
    if (name?.includes("hr") || type === "hr")
      return "hr/logo/2025/clikkle%20hr.png";

    // fallback to default if still nothing
    return s.logo || "hr/logo/2025/clikkle%20hr.png";
  };

  const getDisplayTitle = (s) => {
    const type = s.type?.toLowerCase();
    const name = s.name?.toLowerCase() || s.orgName?.toLowerCase();

    if (name?.includes("file") || type === "file" || type === "files") return "Clikkle Files";
    if (name?.includes("esign") || name?.includes("e-sign") || type === "esign")
      return "Clikkle E-Sign";
    if (name?.includes("project") || type === "project" || type === "projects")
      return "Clikkle Projects";
    if (name?.includes("chat") || type === "chat") return "Clikkle Chat";
    if (name?.includes("campaign") || type === "campaigns")
      return "Clikkle Campaigns";
    if (name?.includes("app") || name?.includes("worksuite") || type === "app" || type === "worksuite")
      return "Clikkle Worksuite";
    // if (name?.includes("ads") || type === "ads") return "Clikkle Ads";
    // if (name?.includes("crm") || type === "crm") return "Clikkle CRM";
    // if (name?.includes("host") || type === "host") return "Clikkle Host";
    // if (name?.includes("launch") || type === "launch") return "Clikkle Launch";
    // if (name?.includes("mail") || type === "mail") return "Clikkle Mail";
    // if (name?.includes("pitch") || type === "pitch") return "Clikkle Pitch";
    if (name?.includes("hr") || type === "hr") return "Clikkle HR";

    return s.title || "Clikkle HR";
  };

  const getUnitLabel = (s) => {
    if (s.name === "Clikkle Files" || s.type === "file") return " Files";
    if (s.type === "campaigns") return " Users";
    if (s.type === "chat") return " Users";
    return " Users";
  };

  const onPurchaseClick = (s) => {
    if (s.name === "Clikkle Files" || s.type === "file") {
      if (typeof handlePurchaseFiles === "function")
        return handlePurchaseFiles(s._id);
    }
    if (s.name === "Clikkle E-Sign" || s.type === "esign") {
      if (typeof handlePurchaseEsign === "function")
        return handlePurchaseEsign(s._id);
    }
    if (s.name === "Clikkle Projects" || s.type === "project") {
      if (typeof handlePurchaseProjects === "function")
        return handlePurchaseProjects(s._id);
    }
    if (s.type === "chat") {
      if (typeof handlePurchaseChat === "function")
        return handlePurchaseChat(s._id);
    }
    if (s.type === "campaigns") {
      if (typeof handlePurchaseCampaigns === "function")
        return handlePurchaseCampaigns(s._id);
    }
    if (s.type === "app" || s.type === "worksuite") {
      if (typeof handlePurchaseWorksuite === "function")
        return handlePurchaseWorksuite(s._id);
    }
    if (typeof handlePurchase === "function") return handlePurchase(s._id);
  };

  const displayTotal = (service) => service.totalEmployees ?? 0;
  return (
    <Box
      sx={{
        paddingBottom: { xs: "60px", sm: "20px" },
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          gap: 2,
          mt: 2,
          mx: 3,
        }}
      >
        {loading ? (
          <>
            <Box sx={{ gridColumn: "1 / -1", mb: 2, textAlign: "center" }}>
              <Typography variant="h6" color="textSecondary">
                Loading Free Subscriptions...
              </Typography>
            </Box>
            {Array.from({ length: 9 }).map((_, index) => (
              <Box
                key={index}
                sx={{
                  borderRadius: "12px",
                  p: 2,
                  backgroundColor: mode === "light" ? "#fff" : "#141414",
                  border: `1px solid ${mode === "light" ? "#e5e7eb" : "#2E2E2E"
                    }`,
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Skeleton
                    variant="rectangular"
                    width={isMobile ? 50 : 80}
                    height={isMobile ? 50 : 80}
                    sx={{ borderRadius: 2, mr: 2 }}
                    animation="pulse"
                  />
                  <Box sx={{ flexGrow: 1 }}>
                    <Skeleton
                      variant="text"
                      width="70%"
                      height={30}
                      animation="pulse"
                    />
                    <Skeleton
                      variant="text"
                      width="50%"
                      height={20}
                      animation="pulse"
                    />
                  </Box>
                </Box>
                <Box sx={{ mt: 2 }}>
                  <Skeleton
                    variant="rectangular"
                    height={10}
                    width="100%"
                    sx={{ borderRadius: 1 }}
                    animation="pulse"
                  />
                  <Skeleton
                    variant="text"
                    width="30%"
                    height={15}
                    sx={{ mt: 1 }}
                    animation="pulse"
                  />
                </Box>
              </Box>
            ))}
          </>
        ) : organizations?.length > 0 ? (
          organizations?.map((service, index) => (
            <Box
              key={index}
              sx={{
                boxShadow: "none",
                backgroundColor: mode === "light" ? "#fff" : "#141414",
                border: `1px solid ${mode === "light" ? "#e5e7eb" : "#2E2E2E"
                  }`,
                borderRadius: "12px",
                p: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 2, sm: 3 } }}>
                <Box
                  sx={{
                    width: { xs: 50, sm: 80 },
                    height: { xs: 50, sm: 80 },
                    borderRadius: "10px",
                    border: `1px solid ${mode === "light" ? "#d1d5db" : "#2E2E2E"
                      }`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Image
                    cdn={getImagePath(service)}
                    alt={`${getDisplayTitle(service)} Icon`}
                    style={{
                      width: "80%",
                      height: "80%",
                      objectFit: "contain",
                    }}
                  />
                </Box>

                <Box sx={{ flexGrow: 1 }}>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "1rem", sm: "1.3rem" },
                      color: mode === "light" ? "#000" : "#fff",
                    }}
                  >
                    {getDisplayTitle(service)}
                  </Typography>
                  {!["file", "files", "esign"].includes(String(service?.type || "").toLowerCase()) && (
                    <Typography
                      sx={{
                        fontWeight: "medium",
                        fontSize: { xs: "0.8rem", sm: "0.9rem" },
                        color: mode === "light" ? "#4b5563" : "#9ca3af",
                        mt: 0.5
                      }}
                    >
                      <span style={{ fontWeight: "normal" }}>Organization: </span>
                      {service.name || service.orgName || "Cant Find the Name"}
                    </Typography>
                  )}
                  <Typography
                    sx={{
                      color: "#A5A5A5",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      fontSize: { xs: "0.75rem", sm: "0.875rem" },
                      mt: 0.5
                    }}
                  >
                    {displayTotal(service)}
                    {getUnitLabel(service)}
                    <span style={{ color: "#C5B03D", ml: 1 }}>★</span>
                    <span style={{ color: "#C5B03D" }}>{service.planName || "Free"}</span>
                  </Typography>
                </Box>
              </Box>

              <div
                className="w-full "
                style={{ marginTop: "20px", marginBottom: "10px" }}
              >
                <LinearProgress
                  variant="determinate"
                  value={percentage}
                  color="primary"
                  sx={{
                    height: 6,
                    borderRadius: "4px",
                    backgroundColor: "#2279FF3B",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#0080FF",
                    },
                  }}
                />

                <Typography
                  variant="caption"
                  sx={{
                    color: "#0080FF",
                    mt: 0.5,
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                  }}
                >
                  {formatBytes(used)} used of{" "}
                  {currentStorage?.permissions?.noOfAllowed}{" "}
                  {currentStorage?.permissions?.format}
                </Typography>
              </div>

              <Box sx={{ mt: 2 }}>
                <Button
                  variant="contained"
                  fullWidth={isMobile}
                  sx={{
                    backgroundColor: "#3767B1",
                    color: "#fff",
                    borderRadius: "8px",
                    px: { xs: 2, sm: 4 },
                    py: { xs: 0.8, sm: 1 },
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                    textTransform: "none",
                    fontWeight: 500,
                    ":hover": {
                      backgroundColor: "#1E40AF",
                    },
                  }}
                  onClick={() => onPurchaseClick(service)}
                >
                  Purchase
                </Button>
              </Box>
            </Box>
          ))
        ) : (
          <Box
            width="100%"
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            height="300px"
            gridColumn="1 / -1"
            textAlign="center"
            sx={{ color: "#888" }}
          >
            <Typography variant="h6">No Free Subscriptions Found</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

// };

export default Free;
